import { UserProfile } from "@api/models/UserProfile";
import { ImportRowData, UserProfileDuplicate } from "../types";

/**
 * Получение строки из значений свойств объекта по полям
 * @param item { a: 1, b: 2 }
 * @param keys ['a', 'b', 'c']
 * @returns '12'
 */
const getValue = <T extends Record<string, string>>(item: T, keys: string[]) => {
    return keys.map(key => item[key]).join('');
};

/**
 * Возвращает список следующего типа Map<field, UserProfile | UserProfile[]>[]
 * в качестве ключа в Map выступает значение свойства объекта data название которого совпадает с одним из полей @param fields
 * значение ключа Map может конкатинироваться если в элемента списка полей является масив с 2-мя и более элементами
 * и в объекте найдены ключи которые совпадают с этими полями
 * Возвращаемая структура нужна для поиска в ней объектов по значениями свойств этих объектов
 * @param data:
 * [
 *     {
 *          a: "01",
 *          b: "02",
 *          c: "03",
 *          d: "04"
 *      },
 *      {
 *          a: "05",
 *          b: "06"
 *      },
 *      {
 *          c: "07"
 *      }
 * ]
 * @param fields: [['a'], ['b'], ['c', 'd']]
 * @returns: [
 *   Map([
 *      [
 *          "01",
 *          {
 *              a: "01",
 *              b: "02",
 *              c: "03",
 *              d: "04"
 *          },
 *          "05",
 *          {
 *              a: "05",
 *              b: "06",
 *          }
 *      ],
 *      [
 *          "02",
 *          {
 *              a: "01",
 *              b: "02",
 *              c: "03",
 *              d: "04"
 *          },
 *          "06",
 *          {
 *              a: "05",
 *              b: "06",
 *          }
 *      ],
 *      [
 *          "0304",
 *          {
 *              a: "01",
 *              b: "02",
 *              c: "03",
 *              d: "04"
 *          },
 *          "07",
 *          {
 *              с: "07",
 *          }
 *      ]
 *   ])
 * ]
 *
 */
export const getMapsByFields = <T extends Record<string, string>>(data: T[], fields: string[][]): Map < string, T | T[] > [] => {

    const maps = fields.map(_ => new Map<string, T | T[]>());

    data.forEach((item) => {

        fields.forEach((key, index) => {

            const value = getValue(item, key);

            if (value || typeof value === "boolean") {

                const map = maps[index];

                if (map.has(value)) {

                    const existValue = map.get(value);

                    if (Array.isArray(existValue)) {
                        map.set(value, [...existValue, item]);
                    }
                    else if (existValue) {
                        map.set(value, [existValue, item]);
                    }
                }
                else {
                    map.set(value, item)
                }
            }
        })
    })

    return maps;
}

export const mapToProfileDuplicate = (userProfile: UserProfile, importedItem: ImportRowData): UserProfileDuplicate => {
    return new UserProfileDuplicate({
        __rowNum__: importedItem.__rowNum__.toString(),
        firstName: importedItem.firstName as string,
        lastName: importedItem.lastName as string,
        company: importedItem.company as string,
        phoneNumber: importedItem.phoneNumber?.toString() as string,
        email: importedItem.email as string,
        profile: userProfile,
        source: importedItem,
        role: null,
        action: undefined
    });
}